<template lang="pug">
  div(data-testid="header")
    header.main-header
      nav.navbar.navbar-static-top
        .container-fluid
          .navbar-header

            router-link.navbar-brand(:to="{name: 'top', params: {init: true}}", data-testid="-main-logo")
              | {{$store.getState('service_name')}}

            //- サイドバー開閉（XSのみ）
            a.sidebar-toggle.visible-xs(v-if="!isLoginPage", href='#', data-toggle='push-menu', @click.prevent="saveSidebar", :data-collapse-screen-size="767 - 17", title="サイドバー")

            //- ヘッダーメニュー開閉（XSのみ）
            button.navbar-toggle.collapsed(data-toggle="collapse" data-target="#jbcard-header-navbar" title="ヘッダーメニュー")
              i.fa.fa-bars

          .collapse.navbar-collapse#jbcard-header-navbar(v-if="!isLoginPage")

            //------------------------------------------------------------
            //- ユーザーメニュー
            //------------------------------------------------------------
            ul.nav.navbar-nav.navbar-right
              //- 名刺の追加
              //- ユーザー画面のみ
              li(style="padding:0 10px;" v-if="!isAdminPage", data-testid="-btn-card-add")
                .btn-group.navbar-btn
                  router-link.btn.btn-success(:to="{name: 'addcard-manual', params: {init: true}}", title="名刺の追加", data-testid="-btn-card-add")
                    span.fa.fa-plus
                    |
                    |
                    span.hidden-sm.hidden-md 名刺の追加
                  a.btn.btn-success.dropdown-toggle(href='#', data-toggle='dropdown', data-testid="-btn-card-add-pulldown")
                    span.fa.fa-caret-down
                  ul.dropdown-menu
                    li
                      router-link(:to="{name: 'addcard-manual', params: {init: true}}")
                        i.fa.bcard-fa-card-plus-pencil.fa-fw.text-red
                        |
                        |
                        | 直接入力して登録
                    li
                      router-link(:to="{name: 'addcard-image', params: {init: true}}")
                        i.fa.bcard-fa-card-plus-image.fa-fw.text-light-blue
                        |
                        |
                        | 画像から登録
                    li
                      router-link(:to="{name:'addcard-csv', params: {init: true}}" title="CSVから一括登録")
                        i.fa.bcard-fa-card-plus-csv.fa-fw.text-green
                        |
                        |
                        | CSVから一括登録

              //- お知らせ
              //- ユーザー画面のみ
              information-digest(v-if="!isAdminPage && !isMgmt", data-testid="information-menu")

              //- ユーザーメニュー
              li.dropdown.user.user-menu(data-testid="-user-menu")
                a.dropdown-toggle(href='#' data-toggle='dropdown')
                  div.bcard-ui-userdata(:title="login_user.full_name" data-testid="-login-user-name")
                    span.fa.fa-user
                    span.hidden-sm.hidden-md
                      //- 通常ログイン
                      span &nbsp;{{login_user.full_name}}
                  div.hidden-sm.hidden-md.text-muted
                    small
                      span.fa.fa-fw.fa-clock-o
                      span 前回ログイン {{login_user.formatted_lastlogin || 'なし'}}

                ul.dropdown-menu
                  //- ユーザー画面のみ
                  template(v-if="!isAdminPage")
                    li.user-header(v-if="!isMgmt")
                      img(:src="app_imgsrc.now_loading", v-src:thumbnail="login_user.image_url")
                      p
                        //- 通常ログイン
                        | {{login_user.full_name}}
                        small(v-if="login_user.dept") {{login_user.dept}}
                        //- else
                          //- 代理操作
                          | 坂口 伸介
                          small 総務部, マーケティング部
                        br.hidden-xs.hidden-lg
                        small.hidden-xs.hidden-lg 前回ログイン {{login_user.formatted_lastlogin || 'なし'}}

                    //- 通常ログインのみ
                    li.user-body(v-if="!isMgmt && !isAgentPage")
                      router-link(:to="{name: 'ProfileSetting', params: {init: true}}", data-testid="-link-prof-set")
                        span.glyphicon.glyphicon-user
                        | プロフィール
                      router-link(:to="{name: 'AgentSetting', params: {init: true}}", data-testid="-link-agent-set")
                        span.fa.fa-users
                        | 代理操作ユーザー設定
                      router-link(:to="{name: 'pvtag', params: {init: true}}")
                        span.fa.fa-tags
                        | 個人タグ
                      router-link(v-if="isNisfaEnabled", :to="{name: 'PvNisfaIntegrationSettings', params: {init: true}}")
                        span.fa.fa-fw.fa-puzzle-piece
                        | Sales Force Assistant 連携

                    //- マニュアル
                    li.user-body
                      a(:href="MEISHIBANK2.help.url" target="_blank")
                        span.fa.fa-question
                        | ヘルプ

                  li.user-footer
                    .pull-right
                      button.btn.btn-default(type="button", @click="logout", data-testid="btn-logout") ログアウト
              //- 通常ログインのみ
              li.dropdown.notifications-menu.agents-menu(v-if="useAgent || useMgmt")
                //- TODO [次期]閉じるときもAPIが走るので無駄
                a.dropdown-toggle(href='#', data-toggle='dropdown' title="代理操作" @click="fetchAgents" data-testid="-switch-user-menu")
                  span.fa.fa-user-circle-o
                ul.dropdown-menu(ref="agentDropdown")

                  template(v-if="!isMgmt && useAgent")
                    li.header 代理操作
                    li(v-if="!isAgentPage")
                      ul.menu
                        li(v-for="item in agents", :key="item.id")
                          a(href="#", @click.prevent="openAgentModalConf(item)") {{item.full_name}}
                        li.nodata(v-if="agents.length === 0") 代理操作ができるユーザーはいません。
                    li(v-else): ul.menu: li
                      a(href="#", @click.prevent="agentLogout") 代理操作を終了する

                  template(v-if="!isAgentPage && useMgmt")
                    li.header 管理者切替
                    li: ul.menu: li(data-testid="switch-mgmt-mode")
                      a(v-if="!isMgmt", href="#", @click.prevent="mgmtLogin") 名刺管理者
                      a(v-else, href="#", @click.prevent="mgmtLogout") 名刺管理者を終了する

              //- 設定メニューリンク
              //- 通常ログインのみ
              li.user(v-if="useAdmin")
                router-link(:to="{name: 'admin', params: {init: true}}" title="システム管理者設定", data-testid="-link-admin")
                  span.fa.fa-cog
                    .notification-badge.pull-right(v-if="countUnread > 0")

    app-modal(type="primary", v-model="modalAgentConf.isOpen", data-testid="agent-login-confirm-modal")
      template(slot="title") 代理操作の確認
      p {{modalAgentConf.selectedUser.full_name}} さんの代理操作を開始します。よろしいですか？
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-primary(type="button", @click="agentLogin(modalAgentConf.selectedUser.id); close();", data-testid="-btn-start") 開始
        button.btn.btn-default(type="button", @click="close") キャンセル
</template>

<script>
import Vue from 'vue'
import AppModal from '@/components/templates/AppModal'
import InformationDigest from '@/components/organisms/InfoDigest'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AuthRepository = RepositoryFactory.get('authority')
const AgentRepository = RepositoryFactory.get('agents')
const AnnouncementRepository = RepositoryFactory.get('announcement')

export default {
  name: 'TheHeader',
  components: { AppModal, InformationDigest, Loading },
  data () {
    return {
      // 代理操作
      agents: [],
      modalAgentConf: {
        isOpen: false,
        selectedUser: {}
      },
      // 運営からのお知らせ通知：未読件数
      countUnread: null
    }
  },
  computed: {
    isLoginPage () {
      return this.$route.name === 'login'
    },
    login_user () {
      return (this.$store.state.base.u && this.$store.getState('login_user')) || {}
    },
    useAgent () {
      return !!this.agents.length || this.isAgentPage // 代理対象がいる or 代理中
    },
    useMgmt () {
      return this.login_user.is_admin
    },
    useAdmin () {
      return this.login_user.is_admin
    }
  },
  watch: {
    'login_user.as_agent' (as_agent) {
      // 代理終了時に、ヘッダーメニューアイコンの出し分けをするため発動する
      if (!as_agent) {
        this.fetchAgents()
      }
    },
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.headerAnnouncementsReloader': function (headerAnnouncementsReloader) {
      if (headerAnnouncementsReloader) {
        // 未読の運営からのお知らせを再取得
        this.chkAnnouncements()
      }
    }
  },
  created () {
    this.fetchAgents()
    // 運営からのお知らせチェック
    this.chkAnnouncements()
  },
  methods: {
    /**
     * 通常ログアウト
     */
    logout () {
      if (this.isMgmt) {
        this.$store.commit('finishMgmtMode')
      }

      const vm = this
      AuthRepository.logout()
        .finally(function () {
          Vue.ApiAdapter.clearApiToken()
          vm.$store.commit('delToken')
          vm.$store.commit('resetState')
          vm.$router.push({name: 'login'})
        })
    },
    linkSearch ($event) {
      let form = $event.target
      const name = form.elements.name.value
      const corporate_name = form.elements.corporate_name.value
      const searched = form.elements.searched.value
      // 入力欄をクリアする
      form.elements.name.value = ''
      form.elements.corporate_name.value = ''
      this.$router.push({name: 'search', params: {init: true, searched: searched}, query: {name: name, corporate_name: corporate_name}})
    },
    /**
     * 代理ユーザー一覧取得処理
     */
    fetchAgents () {
      if (this.isAgentPage) {
        return
      }

      const vm = this
      // API実行
      AgentRepository.getRequesters({ page: 1 })
        .then((response) => {
          vm.agents = vm.getApiData(response).data
        })
    },
    /**
     * 代理操作確認モーダルを開く
     * @param selectedUser
     */
    openAgentModalConf (selectedUser) {
      this.modalAgentConf.selectedUser = selectedUser
      this.modalAgentConf.isOpen = true
    },
    /**
     * 代理操作を開始する
     */
    agentLogin (selectedUserId) {
      const vm = this
      AgentRepository.postLogin({id: selectedUserId})
        .then(function (response) {
          // token保存
          const token = vm.getApiData(response).data.token
          // API
          Vue.ApiAdapter.setApiToken(token)
          // store（時間がかかるので後にする）
          vm.$store.commit('resetState')
          vm.$store.dispatch('setToken', token)

          // セッションに埋まったか確認してから遷移するための値
          const oldStateU = vm.$store.state.base.u

          // 次のroute先の権限チェックに必要な情報をセッションに埋めておく
          vm.$store.commit('setInitInfo', {
            company_code: vm.$store.getState('code'),
            sid_corporate: vm.$store.getState('sidc'),
            login_user: {
              as_agent: true
            }
          })

          const intvl = setInterval(() => {
            if (oldStateU !== vm.$store.state.base.u) {
              vm.$router.push({name: 'top', params: {init: true}})
              clearInterval(intvl)
            }
          })
        })
        // エラー時処理
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    /**
     * 代理操作ログアウト
     */
    agentLogout () {
      const vm = this
      AgentRepository.postLogout()
        .then(function (response) {
          // token保存
          const token = vm.getApiData(response).data.token
          // API
          Vue.ApiAdapter.setApiToken(token)
          // store（時間がかかるので後にする）
          vm.$store.commit('resetState')
          vm.$store.dispatch('setToken', token)
        })
        // エラー時処理
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.$router.push({name: 'top', params: {init: true}})
        })
    },
    /**
     * 機能管理操作を開始する
     */
    mgmtLogin () {
      this.$store.commit('startMgmtMode')
      this.$router.push({name: 'top', params: {init: true}})
    },
    /**
     * 機能管理ログアウト
     */
    mgmtLogout () {
      this.$store.commit('finishMgmtMode')
      this.$router.push({name: 'top', params: {init: true}})
    },
    chkAnnouncements: function () {
      // 非システム管理者、または代理中の場合、処理しない
      if (!this.useAdmin || this.isAgentPage) {
        return
      }

      // 運営からのお知らせ通知チェック
      const vm = this
      AnnouncementRepository.getUnreadCount()
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.countUnread = data.count
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    /**
     * サイドバーの開閉状態をクッキーに保存する
     */
    saveSidebar () {
      // サイドバーの開閉状態をチェック
      if (document.body.classList.contains('sidebar-open')) {
        // close
        this.setCookie('sidebar_is_open', '0')
      }
      else {
        // open
        document.body.classList.remove('sidebar-collapse') // 画面サイズSM以上の設定が残ることがあるため
        this.setCookie('sidebar_is_open', '1')
      }
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  margin-top: 51px;
}
</style>
<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
@import '~bootstrap-sass/assets/stylesheets/bootstrap/mixins';
@import '../../assets/sass/project/_adminlte_color';

// 前回ログイン時刻の文字色（ユーザー画面以外）
.skin-purple-light,
.skin-green-light,
.skin-red-light {
  .user-menu small {
    color: #f4f4f4;
  }
}

// 開閉ボタンをヘッダーからサイドバーに移動
// adminLTEに負けないようにセレクタ優先度を上げている
body.bcard header.main-header nav.navbar {
  margin-left: 0;
}

/* 機能ごとのヘッダーカラー */
.bcard-skin-agent {
  .navbar {
    border-bottom: 3px solid $light-black;
  }
}
/*.bcard-skin-manage {
  .navbar {
    border-bottom: 3px solid $green;
  }
}*/
/*.bcard-skin-admin {
  .navbar {
    border-bottom: 3px solid $navy;
  }
}*/

/* ヘッダー固定 */
.main-header {
  position: fixed;
  top: 0;
  width: 100%;
  min-width: $screen-xs-max;

  // ロゴ
  .navbar-brand {
    // サイドバーと幅を合わせる
    width: 230px;
    padding-left: 60px;

    background: url('/static/images/favicon/favicon-96x96.png') 0 0 no-repeat;
    background-size: 50px 50px;
  }

  // 検索
  .navbar-form {
    // フォルダ選択
    button.dropdown-toggle.foldername {
      max-width: 130px;
      // padding-right: $padding-base-vertical;
      padding-left: $padding-base-vertical;

      @include text-overflow;
      .caret {
        position: absolute;
        top: 50%;
        right: $padding-base-vertical;
        margin-top: -2px;
      }
    }
    // 入力欄
    .form-control {
      width: 50%;
    }
  }

  @media (min-width: $screen-sm-min) {
    .navbar-form {
      width: 310px;
    }
  }
  @media (min-width: $screen-md-min) {
    .navbar-form {
      width: 450px;
    }
  }

  // 縮小時：メニューアイコン
  .navbar-toggle {
    padding-top: 6px;
    padding-bottom: 4px;

    font-size: 15px;
  }

  /* ユーザーメニュー */
  @media (min-width: $screen-lg-min) {
    .navbar-nav > .user-menu > .dropdown-toggle {
      padding-top: 5px;
      padding-bottom: 4px;
    }
  }

  .navbar-nav > .user-menu > .dropdown-toggle > .bcard-ui-userdata {
    max-width: 190px;
  }

  // adminLTE上書き
  .navbar-nav > .user-menu > .dropdown-menu {
    li.user-header {
      height: auto;
      max-height: 235px;
      overflow: auto;
      img {
        width: auto;
        height: auto;
        max-width: 200px;
        max-height: 200px;
      }
    }
  }

  .navbar-nav > .user-menu > .dropdown-menu > .user-body {
    border-bottom-color: #ddd;
    border-top-width: 0;

    a {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}
.navbar-nav > .agents-menu >.dropdown-menu {
  > li.header {
    color: #848484;
    font-size: 12px;
  }
  .menu a {
    padding-left: 20px;
  }
  li.nodata {
    padding: 10px;
  }
}

// 運営からのお知らせ有アイコン（●ボッチ）
.notification-badge::after {
  content: "●";
  font-family: 'Courier New', Courier, monospace;
  color: #DD4839;
  position: relative;
  top: -10px;
  right: -0px;
  text-shadow: 0 0 2px #DD4839;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheHeader.vue